//basic
import React, { Component } from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'

//style
import './ServiceProtocols.scss'

//api
import { api } from '../../functions/api'

//custom components
import Search from '../../components/basic/search'
import CustomButton from '../../components/basic/CustomButton'
import CustomTable from '../../components/complex/customTable'
import DeleteDialog from '../../components/global/deleteDialog'

//material-ui
import {
    CircularProgress,
    createMuiTheme,
    MuiThemeProvider,
    Grid,
} from '@material-ui/core'

import { DatePicker } from 'material-ui-pickers'

//other libraries
import queryString from 'query-string'
import Icon from '@mdi/react'
import { mdiCloudUpload } from '@mdi/js'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'

import moment from 'moment'
import 'moment/locale/sk'
import ShowServiceProtocol from './Show/ShowServiceProtocol'

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiInput: {
            formControl: {
                minWidth: '170px'
            },
            underline: {
                '&:after': {
                    borderBottomColor: 'rgba(0, 0, 0, 0.54) !important'
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: 'rgba(0, 0, 0, 0.54) !important'
            },
            focused: {
                color: 'rgba(0, 0, 0, 0.54) !important'
            }
        },
        MuiFormControl: {
            root: {
                marginLeft: '5px',
                bottom: '8px'
            }
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                // backgroundColor: lightBlue.A200,
                // color: 'white',
            }
        },
        MuiPickersClock: {
            pin: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersClockPointer: {
            pointer: {
                backgroundColor: '#FF7800'
            },
            thumb: {
                backgroundColor: '#FF7800',
                borderColor: '#FF7800'
            }
        },
        MuiPickersClockNumber: {
            selected: {
                backgroundColor: '#FF7800'
            }
        },
        MuiPickersDay: {
            day: {
                color: '#777777'
            },
            selected: {
                backgroundColor: '#FF7800',
                '&:hover': {
                    backgroundColor: '#FF7800'
                }
            },
            current: {
                color: '#777777'
            }
        },
        MuiPickersYear: {
            root: {
                color: '#777777',
                '&:hover': {
                    color: '#FF7800'
                }
            },
            selected: {
                color: '#FF7800 !important',
                '&:hover': {
                    color: '#FF7800'
                }
            }
        },
        MuiPickersModal: {
            dialogAction: {
                color: '#777777'
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class ServiceProtocols extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingPage: true,
            loadingTable: true,
            locale: 'sk',
            dateFilterAnchorEl: null,
            selectDateFrom: null,
            selectDateTo: null,
        }
    }

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname)
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.SERVICE_PROTOCOLS)
        this.loadServiceProtocols()
    }
    
    handleDateChange = (field, val) => {
        this.setState({ [field]: val }, () => this.applyDateFilter())
    }
    
    
    applyDateFilter = () => {
        const { selectDateFrom, selectDateTo } =  this.state;
        
        if (! selectDateFrom || ! selectDateTo) {
            this.addQueryToUrl('selectDateFrom', null, 'selectDateTo', null)
            return;
        }
        
        this.addQueryToUrl('selectDateFrom', selectDateFrom.format('YYYY-MM-DD'), 'selectDateTo', selectDateTo.format('YYYY-MM-DD'))
    }

    tableHeader = [
        {
            title: 'product_code',
            numeric: false,
        },
        {
            title: 'shop',
            numeric: false,
        },
        {
            title: 'username',
            numeric: false,
            min_width: '140px',
            sortBy: 'full_name'
        },
        {
            title: 'created_at',
            numeric: false
        },
    ]
    tableBody = [
        'product_code',
        'shop.name',
        'full_name',
        'created_at',
    ]

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES.SERVICE_PROTOCOLS.EXPORT,
            action: 'service-protocol'
        },
        // {
        //     title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
        //     action: 'edit'
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: 'delete'
        // }
    ]

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0

    loadServiceProtocols = async (size = 10, page = 0, searchterm = '', by = '', dir = 'asc') => {
        // if(this.tableReload) {
        //     this.setState({loadingTable: true})
        //     this.apiCallCounter++;
        // }

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)

        let params = {}
        let filters = {}

        params.filters = filters

        if (queries) {
            if (queries.page_number) {
                page = queries.page_number
                params.page = {
                    number: page
                }
            }

            if (queries.page_size) {
                size = queries.page_size
                params.page = {
                    ...(params.page || {}),
                    size: size
                }
            }

            if (queries.by && queries.dir) {
                by = queries.by
                dir = queries.dir
                params.order = []
                params.order.push({
                    by: by,
                    dir: dir
                })
            }

            // if(queries.by) {
            //     by = queries.by
            //     params.order[0] = {
            //                     by: by,
            //                 }
            // }

            // if(queries.dir) {
            //     dir = queries.dir
            //     params.order[0] = {
            //         dir: dir,
            //     }
            // }

            if (queries.searchterm) {
                searchterm = queries.searchterm
                params.searchterm = searchterm
            }

            // if (queries.customer_order_status_id) {
            //     filters.customer_order_status_id = Number(queries.customer_order_status_id)
            //     this.setState({
            //         customer_order_status_id: Number(queries.customer_order_status_id)
            //     })
            // }

            // if (queries.paid_at) {
            //     filters.paid_at = queries.paid_at
            //     this.setState({ paid_at: queries.paid_at })
            // }

            if (queries.selectDateFrom && queries.selectDateTo) {
                filters.created_at = [queries.selectDateFrom, queries.selectDateTo]
                this.setState({ selectDateFrom: moment(queries.selectDateFrom), selectDateTo: moment(queries.selectDateTo) })
            }
        }

        params.filters = filters

        let load_data = await api({
            method: 'get',
            url: 'service-protocols',
            authorization: this.props.internal.user.access_token,
            params: params
            // params:{
            //     searchterm: searchterm,
            //     page:{
            //         number:page,
            //         size:size,
            //     },
            //     order: [
            //         {
            //             by: by,
            //             dir: dir
            //         }
            //     ]
            // }
        })

        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({ loadingTable: false })
            }
        }
        this.setState({ loadingPage: false })

        if (this.tableReload) {
            this.apiCallCounter--
            if (this.apiCallCounter === 0) {
                this.setState({ loadingTable: false })
                this.tableReload = false
            }
        }
    }

    handleChangeRowsPerPage = size => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl('page_size', size)
    }

    handleChangePage = page => {
        this.setState({
            loading: true
        })

        this.addQueryToUrl('page_number', page + 1)
    }

    handleSearch = searchTerm => {
        if (searchTerm.length > 2) {
            this.tableReload = true
            this.addQueryToUrl('searchterm', searchTerm)
        } else {
            this.addQueryToUrl('searchterm', '')
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl('dir', dir, 'by', orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null, load = true) => {
        this.tableReload = true

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if (param2 && value2) {
            queries[param2] = value2
        }

        if (value === null) {
            delete queries[param]
        }

        if (value2 === null) {
            delete queries[param2]
        }

        let new_path = this.props.location.pathname

        new_path += '?'
        for (let key in queries) {
            if (key) {
                new_path += key + '=' + queries[key] + '&'
            }
        }
        new_path = new_path.slice(0, -1)

        this.props.internal.pushRoute(new_path)
        if (load) {
            this.loadServiceProtocols()
        }
    }

    handleFilter = (type, val) => {
        this.setState({ [type]: val.target.value })
        this.addQueryToUrl(type, val.target.value)
    }
    handleDelete = async () => {
        // this.setState({loadingPage: true})
        let id = toJS(this.props.internal.actionDeleteObj.id)

        let delete_data = await api({
            method: 'DELETE',
            url: `service-protocols/${id}`,
            authorization: this.props.internal.user.access_token
        })

        if (delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)

            this.props.internal.setActionDeleteObj({
                module: null,
                id: null
            })

            this.props.internal.setActionDelete()
            this.loadServiceProtocols()
        } else {
            this.props.internal.setSnackbar(delete_data.data.message, true)
        }

        // this.setState({loadingPage: false})
    }
    
    initiateExport = () => {
        
        const {shop_id, selectDateFrom, selectDateTo} = this.state;
        
        const params = {
            shop_id,
            selectDateFrom: selectDateFrom.format('YYYY-MM-DD'),
            selectDateTo: selectDateTo.format('YYYY-MM-DD'),
        };
        
        api({
            method: 'post',
            url: 'service-protocols/export',
            authorization: this.props.internal.user.access_token,
            params
        }).then(response => {
            if (response.success) {
                window.open(response.data.data.url, '_blank')
            }
        })
    }

    render() {
        const routerData = {
            history: this.props.history,
            match: this.props.match,
            location: this.props.location
        }

        return this.state.loadingPage ? (
            <CircularProgress className={'circular-progress'} />
        ) : (
            <MuiThemeProvider theme={theme}>
                {/* dialog pre upravovanie objednavky */}
                {toJS(this.props.internal.actionEdit.edit) && (
                    <ShowServiceProtocol
                        open={toJS(this.props.internal.actionEdit.edit)}
                        onClose={this.handleCloseEditCustomerOrder}
                        title={
                            this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS']
                                .EDIT_CUSTOMER_ORDER
                        }
                    />
                )}

                {toJS(this.props.internal.actionEdit.edit) === false && (
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELETE_ITEM}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                )}
                <div className={'shopsContainer customerOrderStatuses'}>
                    <div className={'searchBoxFilters flex space-between mb-first-line'}>
                        <Grid container>
                            <Grid item xs={9}>
                                <Search
                                    placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH}
                                    classes={'admin-search'}
                                    onChange={this.handleSearch}
                                    value={this.state.searchTerm}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{textAlign: 'right'}}>
                                     <CustomButton
                                       mystyle={'btn-orange-bg border-radius-18 ml-auto'}
                                       title={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].EXPORT}
                                       onClick={this.initiateExport}
                                       disabled={! this.state.selectDateFrom || ! this.state.selectDateTo}
                                     >
                                         <Icon path={mdiCloudUpload} size={1}/>
                                     </CustomButton>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
    
                    <div className={'filters'}>
                        <Grid container>
                            <Grid item xs={0} md={0} lg={4}></Grid>
                            <Grid item xs={6} md={3} lg={2}></Grid>
    
                            <Grid item xs={6} md={3} lg={2}></Grid>
    
                            <Grid item xs={6} md={3} lg={2}>
                                <MuiPickersUtilsProvider utils={MomentUtils} locale={this.state.locale} moment={moment}>
                                    <DatePicker
                                      emptyLabel={''}
                                      okLabel={<span style={{ color: '#FF7800' }}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                      cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                      autoOk
                                      showTabs
                                      allowKeyboardControl
                                      labelFunc={date => (date ? date.format('DD.MM.YYYY') : '')}
                                      disableFuture
                                      clearLabel={this.props.translate.i18n.GLOBAL.BUTTONS.CLEAR}
                                      // minDate={new Date("2018-01-01")}
                                      // value={selectedDateFrom}
                                      value={this.state.selectDateFrom}
                                      label={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].CREATED_AT_FROM}
                                      clearable
                                      maxDate={this.state.selectDateTo || undefined}
                                      onChange={(date) => this.handleDateChange('selectDateFrom', date)}
                                      // ref={ref => this.datePicker = ref}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} md={3} lg={2}>
                                <MuiPickersUtilsProvider utils={MomentUtils} locale={this.state.locale} moment={moment}>
                                    <DatePicker
                                      emptyLabel={''}
                                      okLabel={<span style={{ color: '#FF7800' }}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                      cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                      autoOk
                                      showTabs
                                      allowKeyboardControl
                                      labelFunc={date => (date ? date.format('DD.MM.YYYY') : '')}
                                      // disableFuture
                                      clearLabel={this.props.translate.i18n.GLOBAL.BUTTONS.CLEAR}
                                      // minDate={new Date("2018-01-01")}
                                      // value={selectedDateFrom}
                                      value={this.state.selectDateTo}
                                      label={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].CREATED_AT_TO}
                                      clearable
                                      minDate={this.state.selectDateFrom || undefined}
                                      onChange={(date) => this.handleDateChange('selectDateTo', date)}
                                      // ref={ref => this.datePicker = ref}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    </div>
                    {this.state.loadingTable ? (
                        <CircularProgress className={'circular-progress'} />
                    ) : (
                        // null
                        <div className={'customersOrderTable'}>
                            <CustomTable
                                dropDownMenuItems={this.dropDownMenuItems}
                                module={'/service_protocols'}
                                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                                handleChangePage={this.handleChangePage}
                                handleSort={this.handleSort}
                                header={this.tableHeader}
                                body={this.tableBody}
                            />
                        </div>
                    )}
                </div>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/ServiceProtocols/ServiceProtocols.jsx